import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_ALCOM_SCORE,
  GET_ALL_MISSING_ALERTS,
  GET_AWS_CHART_DATA,
  GET_AWS_REFRESH,
  GET_AWS_SCAN,
  GET_AWS_SCORES,
  GET_CLOUD_DETAILS,
  GET_COMPLETED_ALERTS,
  GET_MASTER_NOTIFICATION_CHANNELS,
  GET_MASTER_RESOURCES,
  GET_MASTER_SYSTEMS,
  GET_MISSING_ALERTS,
  GET_MONITORING_SYSTEMS,
  GET_NEW_RELIC_COMPLETED_ALERTS,
  GET_NEW_RELIC_RESOURCES,
  GET_NEWRELIC_DEFAULT_THRESHOLD,
  GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD,
  GET_NEWRELIC_METRICS,
  GET_NEWRELIC_MISSING_ALERTS,
  GET_NEWRELIC_REFRESH,
  GET_NEWRELIC_SCAN,
  GET_NEWRELIC_SCORES,
  GET_NOTIFICATION_CHANNELS,
  GET_PROFILE,
  GET_SCORES,
  GET_TODO,
  GET_RECENTLY_ADDED_RESOURCES_AWS,
  GET_RECENTLY_ADDED_RESOURCES_AZURE,
  GET_RECENTLY_ADDED_RESOURCES_GCP,
  GET_RECENTLY_ADDED_RESOURCES_DATADOG,
  GET_RECENTLY_ADDED_RESOURCES_NEWRELIC,
  GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS,
  GET_RECENTLY_ADDED_RESOURCES_SPLUNK,
  GET_ALCOM_SCORE_BY_SERVICE_IDS,
  GET_RECENTLY_ADDED_RESOURCES_DYNATRACE,
  GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS, GET_RECENTLY_ADDED_RESOURCES_OCI, GET_MASTER_LOGGING_SYSTEMS,
  GET_LOGGING_SYSTEMS, GET_RECENTLY_ADDED_RESOURCES_GRAFANA, GET_RECENTLY_ADDED_RESOURCES_SIGNOZ
} from "./actionTypes";
import {
  getAlcomScoreFail,
  getAlcomScoreSuccess,
  getAllMissingAlertsFail,
  getAllMissingAlertsSuccess,
  getAWSChartDataFail,
  getAWSChartDataSuccess,
  getAwsRefreshFail,
  getAwsRefreshSuccess,
  getAwsScanFail,
  getAwsScanSuccess,
  getAwsScoresFail,
  getAwsScoresSuccess,
  getCloudDetailsFail,
  getCloudDetailsSuccess,
  getCompletedAlertsFail,
  getCompletedAlertsSuccess,
  getMasterNotificationChannelsFail,
  getMasterNotificationChannelsSuccess,
  getMasterResourcesFail,
  getMasterResourcesSuccess,
  getMasterSystemsFail,
  getMasterSystemsSuccess,
  getMissingAlertsFail,
  getMissingAlertsSuccess,
  getMonitoringSystemsFail,
  getMonitoringSystemsSuccess,
  getNewRelicCompletedAlertsFail,
  getNewRelicCompletedAlertsSuccess,
  getNewRelicDefaultThresholdFail,
  getNewRelicDefaultThresholdSuccess,
  getNewRelicDynamicDefaultThresholdFail,
  getNewRelicDynamicDefaultThresholdSuccess,
  getNewRelicMetricsFail,
  getNewRelicMetricsSuccess,
  getNewRelicMissingAlertsFail,
  getNewRelicMissingAlertsSuccess,
  getNewRelicRefreshFail,
  getNewRelicRefreshSuccess,
  getNewRelicResourcesFail,
  getNewRelicResourcesSuccess,
  getNewRelicScanFail,
  getNewRelicScanSuccess,
  getNewRelicScoresFail,
  getNewRelicScoresSuccess,
  getNotificationChannelsFail,
  getNotificationChannelsSuccess,
  getProfileFail,
  getProfileSuccess,
  getScoresFail,
  getScoresSuccess,
  getTodoFail,
  getTodoSuccess,
  getRecentlyAddedResourcesAWS,
  getRecentlyAddedResourcesAWSSuccess,
  getRecentlyAddedResourcesAWSFail,
  getRecentlyAddedResourcesAzureFail,
  getRecentlyAddedResourcesAzureSuccess,
  getRecentlyAddedResourcesGCPFail,
  getRecentlyAddedResourcesGCPSuccess,
  getRecentlyAddedResourcesDatadogFail,
  getRecentlyAddedResourcesDatadogSuccess,
  getRecentlyAddedResourcesNewRelicFail,
  getRecentlyAddedResourcesNewRelicSuccess,
  getRecentlyAddedResourcesAppDynamicsFail,
  getRecentlyAddedResourcesSplunkFail,
  getRecentlyAddedResourcesSplunkSuccess,
  getRecentlyAddedResourcesAppDynamicsSuccess,
  getAlcomScoreByServiceIdsFail,
  getAlcomScoreByServiceIdsSuccess,
  getRecentlyAddedResourcesDynatraceSuccess,
  getRecentlyAddedResourcesDynatraceFail,
  getRecentlyAddedResourcesSyntheticsSuccess,
  getRecentlyAddedResourcesSyntheticsFail,
  getRecentlyAddedResourcesOciSuccess,
  getRecentlyAddedResourcesOciFail,
  getMasterLoggingSystemsSuccess,
  getMasterLoggingSystemsFail,
  getLoggingSystemsSuccess,
  getLoggingSystemsFail,
  getRecentlyAddedResourcesGrafanaSuccess,
  getRecentlyAddedResourcesGrafanaFail, getRecentlyAddedResourcesSignozSuccess, getRecentlyAddedResourcesSignozFail
} from "./actions";

//Include Both Helper File with needed methods
import {
  getAlcomScoreUrl,
  getAlertsFullUrl,
  getAllMissingAlertsUrl,
  getAWSChartsDataUrl,
  getAwsScanUrl,
  getCloudDetailsUrl,
  getMasterNotificationChannelsUrl,
  getMasterResourcesUrl,
  getMasterSystemsUrl,
  getMissingAlertsUrl,
  getMonitoringSystemsUrl,
  getNewRelicCompletedAlertsUrl,
  getNewRelicDefaultThresholdUrl,
  getNewRelicMetricsUrl,
  getNewRelicMissingAlertsUrl,
  getNewRelicRefreshResourcesUrl,
  getNewRelicResourcesUrl,
  getNotificationChannelsUrl,
  getProfiles,
  getRefreshResources,
  getScoresUrl,
  getTodos,
  getRecentlyAddedResourcesAWSUrl,
  getRecentlyAddedResourcesAzureUrl,
  getRecentlyAddedResourcesDatadogUrl,
  getRecentlyAddedResourcesGCPUrl,
  getRecentlyAddedResourcesNewRelicUrl,
  getRecentlyAddedResourcesAppDynamicsUrl,
  getRecentlyAddedResourcesSplunkUrl,
  getAlcomScoreByServiceIdsUrl,
  getRecentlyAddedResourcesDynatraceUrl,
  getRecentlyAddedResourcesSyntheticsUrl, getRecentlyAddedResourcesOciUrl, getMasterLoggingSystems,
  getLoggingSystemsUrl, getRecentlyAddedResourcesGrafanaUrl, getRecentlyAddedResourcesSignozUrl
} from "../../helpers/fakebackend_helper";
import { showNotification } from "components/Common/notification";
import { func } from "prop-types";
import { take } from "lodash";

function* onGetAlcomScoreByServiceIds({payload: service_ids}) {
  try {
    const response = yield call(getAlcomScoreByServiceIdsUrl, service_ids);
    yield put(getAlcomScoreByServiceIdsSuccess(response));
  } catch(error) {
    yield put(getAlcomScoreByServiceIdsFail(error))
  }
}

function* onGetTodo() {
  try {
    const response = yield call(getTodos);
    yield put(getTodoSuccess(response));
  } catch (error) {
    yield put(getTodoFail(error));
  }
}

function* onGetProfile() {
  try {
    const response = yield call(getProfiles);
    yield put(getProfileSuccess(response));
  } catch (error) {
    yield put(getProfileFail(error));
  }
}

function* onGetScores(scan_id) {
  try {
    const response = yield call(getScoresUrl, scan_id.payload);
    yield put(getScoresSuccess(response));
  } catch (error) {
    yield put(getScoresFail(error));
  }
}

function* onGetMasterResources() {
  try {
    const response = yield call(getMasterResourcesUrl);
    yield put(getMasterResourcesSuccess(response));
  } catch (error) {
    yield put(getMasterResourcesFail(error));
  }
}

function* onGetMasterNotificationChannels() {
  try {
    const response = yield call(getMasterNotificationChannelsUrl);
    yield put(getMasterNotificationChannelsSuccess(response));
  } catch (error) {
    yield put(getMasterNotificationChannelsFail(error));
  }
}

function* onGetAwsRefresh() {
  try {
    const response = yield call(getRefreshResources);
    yield put(getAwsRefreshSuccess(response));
    if (response.scan_completed === false){
      showNotification('error', response.message);
    }
  } catch (error) {
    yield put(getAwsRefreshFail(error));
    if (error.response.data.message = "Plan has expired") {
      showNotification("error", "Your subscription has expired. Please renew!");
    }
  }
}

function* onGetMissingAlerts(alert_id) {
  try {
    const response = yield call(getMissingAlertsUrl, alert_id.payload);
    let final_response = {};
    response.map(item => {
      if (final_response[item.monitored_resource_id] === undefined) {
        final_response[item.monitored_resource_id] = []
      }
      final_response[item.monitored_resource_id].push(item)
    })
    yield put(getMissingAlertsSuccess(final_response));
  } catch (error) {
    yield put(getMissingAlertsFail(error));
  }
}

function* onGetMasterSystems() {
  try {
    const response = yield call(getMasterSystemsUrl);
    yield put(getMasterSystemsSuccess(response));
  } catch (error) {
    yield put(getMasterSystemsFail(error));
  }
}

function* onGetCloudDetails() {
  try {
    const response = yield call(getCloudDetailsUrl);
    yield put(getCloudDetailsSuccess(response));
  } catch (error) {
    yield put(getCloudDetailsFail(error));
  }
}

function* onGetNotificationChannels() {
  try {
    const response = yield call(getNotificationChannelsUrl);
    yield put(getNotificationChannelsSuccess(response));
  } catch (error) {
    yield put(getNotificationChannelsFail(error));
  }
}

function* onGetCompletedAlerts() {
  try {
    const response = yield call(getAlertsFullUrl);
    yield put(getCompletedAlertsSuccess(response));
  } catch (error) {
    yield put(getCompletedAlertsFail(error.message));
  }
}

function* onGetNewRelicResources() {
  try {
    const response = yield call(getNewRelicResourcesUrl);
    yield put(getNewRelicResourcesSuccess(response));
  } catch (error) {
    yield put(getNewRelicResourcesFail(error.message));
  }
}

function* onGetMonitoringSystems() {
  try {
    const response = yield call(getMonitoringSystemsUrl);
    yield put(getMonitoringSystemsSuccess(response));
  } catch (error) {
    yield put(getMonitoringSystemsFail(error.message));
  }
}

function* onGetNewRelicMetrics() {
  try {
    const response = yield call(getNewRelicMetricsUrl);
    yield put(getNewRelicMetricsSuccess(response));
  } catch (error) {
    yield put(getNewRelicMetricsFail(error.message));
  }
}

function* onGetNewRelicMissingAlerts(alert_id) {
  try {
    const response = yield call(getNewRelicMissingAlertsUrl, alert_id.payload);
    var final_response = {}
    response.map(item => {
      if (final_response[item.monitored_resource_id] === undefined) {
        final_response[item.monitored_resource_id] = []
      }
      final_response[item.monitored_resource_id].push(item)
    })
    yield put(getNewRelicMissingAlertsSuccess(final_response));
  } catch (error) {
    yield put(getNewRelicMissingAlertsFail(error));
  }
}

function* onGetNewRelicDefaultThreshold(threshold_type) {
  try {
    const response = yield call(getNewRelicDefaultThresholdUrl, threshold_type.payload);
    yield put(getNewRelicDefaultThresholdSuccess(response));
  } catch (error) {
    yield put(getNewRelicDefaultThresholdFail(error.message));
  }
}

function* onGetNewRelicDynamicDefaultThreshold(threshold_type) {
  try {
    const response = yield call(getNewRelicDefaultThresholdUrl, threshold_type.payload);
    yield put(getNewRelicDynamicDefaultThresholdSuccess(response));
  } catch (error) {
    yield put(getNewRelicDynamicDefaultThresholdFail(error.message));
  }
}

function* onGetNewRelicCompletedAlerts() {
  try {
    const response = yield call(getNewRelicCompletedAlertsUrl);
    yield put(getNewRelicCompletedAlertsSuccess(response));
  } catch (error) {
    yield put(getNewRelicCompletedAlertsFail(error.message));
  }
}

function* onGetAwsScan() {
  try {
    const response = yield call(getAwsScanUrl);
    yield put(getAwsScanSuccess(response));
  } catch (error) {
    yield put(getAwsScanFail(error.message));
  }
}

function* onGetNewRelicScan() {
  try {
    const response = yield call(getAwsScanUrl);
    yield put(getNewRelicScanSuccess(response));
  } catch (error) {
    yield put(getNewRelicScanFail(error.message));
  }
}

function* onGetNewRelicRefresh() {
  try {
    const response = yield call(getNewRelicRefreshResourcesUrl);
    yield put(getNewRelicRefreshSuccess(response));
    if (response.scan_completed === false){
      showNotification('error', response.message);
    }
  } catch (error) {
    yield put(getNewRelicRefreshFail(error.message));
    if (error.response.data.message = "Plan has expired") {
      showNotification("error", "Your subscription has expired. Please renew!");
    }
  }
}

function* onGetAwsScores(scan_id) {
  try {
    const response = yield call(getScoresUrl, scan_id.payload);
    var final_response = {}
    var actual_score_count = 0;
    var expected_score_count = 0;
    var created_at = "";
    response.map(item => {
      actual_score_count += item.actual_alert_count;
      expected_score_count += item.expected_alert_count;
      created_at = item.created_at;
    })
    final_response[scan_id.payload] = {
      "actual_score_count": actual_score_count,
      "expected_score_count": expected_score_count,
      "created_at": created_at
    };
    yield put(getAwsScoresSuccess(final_response));
  } catch (error) {
    yield put(getAwsScoresFail(error.message));
  }
}

function* onGetNewRelicScores(scan_id) {
  try {
    const response = yield call(getScoresUrl, scan_id.payload);
    var final_response = {}
    var actual_score_count = 0;
    var expected_score_count = 0;
    response.map(item => {
      actual_score_count += item.actual_alert_count;
      expected_score_count += item.expected_alert_count;
    })
    final_response[scan_id.payload] = {
      "actual_score_count": actual_score_count,
      "expected_score_count": expected_score_count
    };
    yield put(getNewRelicScoresSuccess(final_response));
  } catch (error) {
    yield put(getNewRelicScoresFail(error.message));
  }
}

function* onGetAllMissingAlerts() {
  try {
    const response = yield call(getAllMissingAlertsUrl);
    yield put(getAllMissingAlertsSuccess(response));
  } catch (error) {
    yield put(getAllMissingAlertsFail(error.message));
  }
}

function* onGetAlcomScore() {
  try {
    const response = yield call(getAlcomScoreUrl);
    yield put(getAlcomScoreSuccess(response));
  } catch (error) {
    yield put(getAlcomScoreFail(error.message));
  }
}

function* onGetAWSChartsData() {
  try {
    const response = yield call(getAWSChartsDataUrl);
    yield put(getAWSChartDataSuccess(response));
  } catch (error) {
    yield put(getAWSChartDataFail(error.message));
  }
}

function* onGetRecentlyAddedResourcesAWS({payload: data}) {
  try {
    const response = yield call(getRecentlyAddedResourcesAWSUrl, data);
    yield put(getRecentlyAddedResourcesAWSSuccess(response));
  } catch (error) {
    yield put(getRecentlyAddedResourcesAWSFail(error))
  }
}

function* onGetRecentlyAddedResourcesAzure({payload: data}) {
  try {
    const response = yield call(getRecentlyAddedResourcesAzureUrl, data);
    yield put(getRecentlyAddedResourcesAzureSuccess(response));
  } catch (error) {
    yield put(getRecentlyAddedResourcesAzureFail(error))
  }
}

function* onGetRecentlyAddedResourcesGCP({payload: data}) {
  try {
    const response = yield call(getRecentlyAddedResourcesGCPUrl, data);
    yield put(getRecentlyAddedResourcesGCPSuccess(response));
  } catch (error) {
    yield put(getRecentlyAddedResourcesGCPFail(error))
  }
}

function* onGetRecentlyAddedResourcesDatadog({payload: data}) {
  try {
    const response = yield call(getRecentlyAddedResourcesDatadogUrl, data);
    yield put(getRecentlyAddedResourcesDatadogSuccess(response));
  } catch (error) {
    yield put(getRecentlyAddedResourcesDatadogFail(error))
  }
}

function* onGetRecentlyAddedResourcesNewRelic({payload: data}) {
  try {
    const response = yield call(getRecentlyAddedResourcesNewRelicUrl, data);
    yield put(getRecentlyAddedResourcesNewRelicSuccess(response));
  } catch (error) {
    yield put(getRecentlyAddedResourcesNewRelicFail(error))
  }
}

function* onGetRecentlyAddedResourcesAppDynamics({payload: data}) {
  try{
    const response = yield call(getRecentlyAddedResourcesAppDynamicsUrl, data)
    yield put(getRecentlyAddedResourcesAppDynamicsSuccess(response));
  }catch(error) {
    yield put(getRecentlyAddedResourcesAppDynamicsFail(error))
  }
}

function * onGetRecentlyAddedResourcesGrafana({payload: data}) {
  try{
    const response = yield call(getRecentlyAddedResourcesGrafanaUrl, data)
    yield put(getRecentlyAddedResourcesGrafanaSuccess(response));
  }catch(error) {
    yield put(getRecentlyAddedResourcesGrafanaFail(error))
  }
}

function * onGetRecentlyAddedResourcesSignoz({payload: data}) {
  try{
    const response = yield call(getRecentlyAddedResourcesSignozUrl, data)
    yield put(getRecentlyAddedResourcesSignozSuccess(response));
  }catch(error) {
    yield put(getRecentlyAddedResourcesSignozFail(error))
  }
}

function* onGetRecentlyAddedResourcesSplunk({payload: data}) {
  try{
    const response = yield call(getRecentlyAddedResourcesSplunkUrl, data)
    yield put(getRecentlyAddedResourcesSplunkSuccess(response));
  }catch(error) {
    yield put(getRecentlyAddedResourcesSplunkFail(error))
  }
}

function* onGetRecentlyAddedResourcesDynatrace({payload: data}) {
    try{
        const response = yield call(getRecentlyAddedResourcesDynatraceUrl, data)
        yield put(getRecentlyAddedResourcesDynatraceSuccess(response));
    }catch(error) {
        yield put(getRecentlyAddedResourcesDynatraceFail(error))
    }
}

function* onGetRecentlyAddedResourcesOci({payload: data}) {
    try{
        const response = yield call(getRecentlyAddedResourcesOciUrl, data)
        yield put(getRecentlyAddedResourcesOciSuccess(response));
    }catch(error) {
        yield put(getRecentlyAddedResourcesOciFail(error))
    }
}

function* onGetRecentlyAddedResourcesSyntheticsSuccess({payload:data}){
  try{
    const response = yield call(getRecentlyAddedResourcesSyntheticsUrl,data)
    yield  put(getRecentlyAddedResourcesSyntheticsSuccess(response))
  }catch(error){
    yield put(getRecentlyAddedResourcesSyntheticsFail(error))
  }
}


function* onGetMasterLoggingSystems() {
  try {
    const response = yield call(getMasterLoggingSystems);
    yield put(getMasterLoggingSystemsSuccess(response));
  } catch (error) {
    yield put(getMasterLoggingSystemsFail(error));
  }
}

function* onGetLoggingSystems() {
  try {
    const response = yield call(getLoggingSystemsUrl);
    yield put(getLoggingSystemsSuccess(response));
  } catch (error) {
    yield put(getLoggingSystemsFail(error.message));
  }
}

function* dashboardSaga() {
  yield takeEvery(GET_TODO, onGetTodo);
  yield takeEvery(GET_PROFILE, onGetProfile);
  yield takeEvery(GET_SCORES, onGetScores);
  yield takeEvery(GET_MASTER_RESOURCES, onGetMasterResources);
  yield takeEvery(GET_MASTER_NOTIFICATION_CHANNELS, onGetMasterNotificationChannels);
  yield takeEvery(GET_AWS_REFRESH, onGetAwsRefresh);
  yield takeEvery(GET_MISSING_ALERTS, onGetMissingAlerts);
  yield takeEvery(GET_MASTER_SYSTEMS, onGetMasterSystems);
  yield takeEvery(GET_CLOUD_DETAILS, onGetCloudDetails);
  yield takeEvery(GET_NOTIFICATION_CHANNELS, onGetNotificationChannels);
  yield takeEvery(GET_COMPLETED_ALERTS, onGetCompletedAlerts);
  yield takeEvery(GET_NEW_RELIC_RESOURCES, onGetNewRelicResources);
  yield takeEvery(GET_MONITORING_SYSTEMS, onGetMonitoringSystems);
  yield takeEvery(GET_NEWRELIC_METRICS, onGetNewRelicMetrics);
  yield takeEvery(GET_NEWRELIC_MISSING_ALERTS, onGetNewRelicMissingAlerts);
  yield takeEvery(GET_NEWRELIC_DEFAULT_THRESHOLD, onGetNewRelicDefaultThreshold);
  yield takeEvery(GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD, onGetNewRelicDynamicDefaultThreshold)
  yield takeEvery(GET_NEW_RELIC_COMPLETED_ALERTS, onGetNewRelicCompletedAlerts);
  yield takeEvery(GET_AWS_SCAN, onGetAwsScan);
  yield takeEvery(GET_NEWRELIC_REFRESH, onGetNewRelicRefresh);
  yield takeEvery(GET_AWS_SCORES, onGetAwsScores);
  yield takeEvery(GET_NEWRELIC_SCORES, onGetNewRelicScores);
  yield takeEvery(GET_NEWRELIC_SCAN, onGetNewRelicScan);
  yield takeEvery(GET_ALL_MISSING_ALERTS, onGetAllMissingAlerts);
  yield takeEvery(GET_ALCOM_SCORE, onGetAlcomScore);
  yield takeEvery(GET_AWS_CHART_DATA, onGetAWSChartsData);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_AWS, onGetRecentlyAddedResourcesAWS);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_AZURE, onGetRecentlyAddedResourcesAzure);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_GCP, onGetRecentlyAddedResourcesGCP);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_NEWRELIC, onGetRecentlyAddedResourcesNewRelic);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_DATADOG, onGetRecentlyAddedResourcesDatadog);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS, onGetRecentlyAddedResourcesAppDynamics);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_GRAFANA, onGetRecentlyAddedResourcesGrafana);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_SPLUNK, onGetRecentlyAddedResourcesSplunk);
  yield takeEvery(GET_ALCOM_SCORE_BY_SERVICE_IDS , onGetAlcomScoreByServiceIds);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_DYNATRACE, onGetRecentlyAddedResourcesDynatrace);
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS,onGetRecentlyAddedResourcesSyntheticsSuccess)
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_OCI,onGetRecentlyAddedResourcesOci)
  yield takeEvery(GET_MASTER_LOGGING_SYSTEMS, onGetMasterLoggingSystems)
  yield takeEvery(GET_LOGGING_SYSTEMS, onGetLoggingSystems)
  yield takeEvery(GET_RECENTLY_ADDED_RESOURCES_SIGNOZ, onGetRecentlyAddedResourcesSignoz);
}

export default dashboardSaga;
